<template>
  <div class="global-tabbar-wrapper">
    <van-tabbar route active-color="#ee0a24">
      <van-tabbar-item
        v-for="(item, index) of tabs"
        :key="index"
        :to="item.path"
        :icon="item.icon"
        :url="item.url"
      >
        {{ item.title }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
// import { getUserOpenid, getUserAgencyStatus } from '../api/api-user';

export default {
  // data() {
  //   return {
  //     isGuider: false,
  //     guiderUrl: '',
  //     openid: undefined,
  //   };
  // },
  computed: {
    ...mapGetters(['spotId']),
    tabs() {
      if (this.spotId === '0') {
        return [
          { path: '/spots_list', icon: 'home-o', title: '景区列表' },
          { path: '/orders_list', icon: 'notes-o', title: '订单' },
        ];
      }
      // if (this.isGuider) {
      //   return [
      //     { path: '/tickets_list', icon: 'home-o', title: '门票列表' },
      //     { path: '/orders_list', icon: 'notes-o', title: '订单' },
      //     { url: this.guiderUrl, icon: 'shop-o', title: '旅行社' },
      //   ];
      // }
      return [
        { path: `/spots_detail/${this.spotId}`, icon: 'home-o', title: '门票列表' },
        { path: '/orders_list', icon: 'notes-o', title: '订单' },
      ];
    },
  },
  // created() {
  //   this.handleGet();
  // },
  // methods: {
  //   async handleGet() {
  //     const openid = await getUserOpenid();
  //     this.openid = openid;
  //     const { status, url } = (await getUserAgencyStatus({ openid })) || {};
  //     if (status) {
  //       this.isGuider = 1;
  //       this.guiderUrl = url;
  //     }
  //   },
  // },
};
</script>
<style lang="less" scoped>
.global-tabbar-wrapper {
  background: #f9fafb;
  position: fixed;
  bottom: 0;
  z-index: 99;
}
</style>
